export interface Policy {
  label: string;
  value: string;
  endpointsCount?: number;
  inheritsFrom?: string;
  isEditable?: string;
}

export interface EditableModuleAndSection {
  moduleId: string;
  sectionId: string;
}

export enum RpcPolicyTemplatesMethod {
  GET_POLICIES_BY_COMPANY = 'getEditablePoliciesByCompany',
}

export enum RpcAction {
  POLICY_TEMPLATES = "PolicyTemplates",
}
